import { VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';

import { Booking, BookingFacade, isNotNullOrUndefined, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-visio-workspace',
  templateUrl: 'visio-workspace.component.html',
  styleUrls: ['./visio-workspace.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisioWorkspaceComponent implements OnInit {
  contact: Booking;
  mainStream: OT.Stream | undefined;
  interactionWorkspaceEnabled: boolean = true;
  isSessionConnected$ = this.visioService.isSessionConnected$;
  publisherCameraStream$ = this.visioService.publisherCameraStream$;
  publisherScreenStream$: Observable<OT.Stream | undefined> = this.visioService.publisherScreenStream$;
  subscriberStreamList$: Observable<OT.Stream[] | undefined> = this.visioService.subscriberStreamList$;
  screenSharingInProcess$: Observable<OT.Stream | undefined> = this.visioService.screenSharingInProcess$;
  selected$ = combineLatest([this.subscriberStreamList$, this.screenSharingInProcess$, this.publisherCameraStream$]).pipe(
    map(([streams, screen, agent]) => {
      const [first] = streams || [];
      if (!!screen) {
        return screen;
      } else if (first) {
        return first;
      } else if (!!agent) {
        return agent;
      } else {
        return undefined;
      }
    })
  );

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly visioService: VisioService,
    private readonly contactFacade: BookingFacade
  ) {}

  ngOnInit() {
    // LOCAL POC LINES
    // this.visioService.initializeSession();
    // this.selected$.subscribe(stream => this.select(stream));

    this.contactFacade.selected$.pipe(isNotNullOrUndefined(), untilDestroyed(this)).subscribe(contact => {
      if (!!contact && !!contact.visioSession) {
        const { openTokApiKey, openTokToken, openTokSession } = contact.visioSession;
        this.visioService.initializeSession(openTokApiKey, openTokToken, openTokSession);
        this.selected$.subscribe(stream => this.select(stream));
      }
    });
  }

  switchWorkspace(workspace: string) {
    if (workspace === 'interaction') {
      this.interactionWorkspaceEnabled = true;
    } else {
      this.interactionWorkspaceEnabled = false;
    }
  }

  select(stream: OT.Stream | undefined) {
    this.mainStream = stream;
    this.cdr.detectChanges();
  }
}
